import { getTranslationKey } from 'helpers/texting';
import { Button, Modal } from 'reactstrap';
import { ModalBody } from 'components/Modal/ModalBody';
import { ModalHeader } from 'components/Modal/ModalHeader';
import { closeSingleImageDownload } from 'store/slices/modals';
import styled from 'styled-components';
import { useDownloadTourModal } from './useDownloadTourModal';

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
  padding-top: 16px;
  position: relative;
  button {
    margin-left: 20px;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    border-bottom: 1px solid #dee2e6;
    width: calc(100% + 32px);
    transform: translateX(-16px);
  }
`;

export const DownloadTourModal = () => {
  const { isOpened, closeModal, startTour } = useDownloadTourModal(closeSingleImageDownload);

  return (
    <Modal
      centered
      isOpen={isOpened}
      toggle={closeModal}
      wrapClassName="modal-primary modal-site download-selection-modal"
      size="medium"
      zIndex={999999}
      backdrop="static"
    >
      <ModalHeader toggle={closeModal}>{getTranslationKey('tourGuide.tip')}</ModalHeader>
      <ModalBody>
        <p>{getTranslationKey('tourGuide.downloadMoreText')}</p>

        <ButtonWrapper>
          <Button className="sb-btn" onClick={closeModal}>
            {getTranslationKey('tourGuide.okay')}
          </Button>
          <Button className="sb-btn" onClick={startTour}>
            {getTranslationKey('tourGuide.startTour')}
          </Button>
        </ButtonWrapper>
      </ModalBody>
    </Modal>
  );
};
